import React from "react";
import PropTypes from "prop-types";

import MetamaskIcon from "../../../assets/images/wallets/metamaskIcon.svg";

import { useTheme } from "styled-components";
import Modal from "../../styled/Modal/Modal";
import { WalletListStyled } from "../style";
import ArrowIcon from "../../ArrowIcon";
import Loader from "react-loader-spinner";

const WalletModal = ({
  show,
  onHide,
  onWalletClickHandler,
  modalLoading,
  onExited,
}) => {
  const theme = useTheme();

  return (
    <Modal show={show} onHide={onHide} centered onExited={onExited}>
      <h4 style={{ fontSize: "2.5rem" }}>Connect Your Wallet</h4>
      <p className="my-5 " style={{ fontSize: "1.6rem", color: "lightgrey" }}>
        By connecting your wallet you agree to our
        <br />{" "}
        <span>
          <a href="https://blockius.s3.ap-southeast-1.amazonaws.com/terms-and-conditions.pdf" style={{ color: "#27DEBF" }}>Terms of Service</a>
        </span>
      </p>
      <WalletListStyled modalLoading>
        <li>
          <div
            tabIndex={0}
            role="button"
            className="wallet-list-item"
            onClick={() => onWalletClickHandler("METAMASK")}
            onKeyPress={() => onWalletClickHandler("METAMASK")}
          >
            <ArrowIcon className="arrow" fill={theme.palette.card.primary} />
            <img
              src={MetamaskIcon}
              alt="metamask icon"
              className="wallet-img"
            />
            {modalLoading && (
              <Loader type="ThreeDots" color="#00BFFF" height={30} width={30} />
            )}
          </div>
        </li>
      </WalletListStyled>
      {/* <p className="info-link mt-4 mb-0">Learn more about wallet</p> */}
    </Modal>
  );
};

WalletModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onWalletClickHandler: PropTypes.func,
  modalLoading: PropTypes.bool,
  onExited: PropTypes.func,
};

export default WalletModal;
